/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  StatementListItemResponse,
  UtxStatementsFindParams
} from './schema'



/**
 * List user's statements, currently support monthy statement only.
 */
export const utxStatementsFind = (
    params?: UtxStatementsFindParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StatementListItemResponse[]>> => {
    return axios.get(
      `/statements`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxStatementsFindQueryKey = (params?: UtxStatementsFindParams,) => [`/statements`, ...(params ? [params]: [])];

    
export type UtxStatementsFindQueryResult = NonNullable<Awaited<ReturnType<typeof utxStatementsFind>>>
export type UtxStatementsFindQueryError = AxiosError<unknown>

export const useUtxStatementsFind = <TData = Awaited<ReturnType<typeof utxStatementsFind>>, TError = AxiosError<unknown>>(
 params?: UtxStatementsFindParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxStatementsFind>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxStatementsFindQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxStatementsFind>>> = ({ signal }) => utxStatementsFind(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxStatementsFind>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

